module.exports = __webpack_public_path__ + "static/media/case4A.3714694.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case4A.mp4
// module id = fncV
// module chunks = 0